import styles from "./ImagePreviewAddOn.module.css";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";

type ImagePreviewAddOnProps = {
  srcs: string[];
};

function ImagePreviewAddOn({ srcs }: ImagePreviewAddOnProps) {
  return (
    <div className={styles["imagePreviewContainer"]}>
      {srcs.slice(0, 3).map((src, i) => (
        <FixaImage className={styles["image"]!} key={i} src={src} />
      ))}
      {srcs.length > 3 && (
        <div className={styles["moreImages"]}>+{srcs.length - 3}</div>
      )}
    </div>
  );
}

export default ImagePreviewAddOn;
